module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-2-Body-Talk-63673c6a89cc300aac129845697f4b26.pdf";